<template>
  <div class="flex flex-col items-center">
    <h2 class="font-nutino font-bold lg:font-extrabold text-[20px] lg:text-[48px] tracking-tight text-center">{{ t('b2b.wellbeing.aspects.title') }}</h2>
    <p class="font-avenir opacity-60 text-[16px] md:text-[30px] mt-[24px] text-center leading-[1.4]">{{ t('b2b.wellbeing.aspects.subtitle') }}</p>
    <div class="flex flex-wrap justify-center gap-x-[29px] md:gap-y-[36px] gap-y-[15px] mt-[24px]">
      <Chip>
        {{  t('b2b.wellbeing.aspects.chip.1') }}
      </Chip>
      <Chip>
       {{  t('b2b.wellbeing.aspects.chip.2') }}
      </Chip>
      <Chip>
        {{  t('b2b.wellbeing.aspects.chip.3') }}
      </Chip>
    </div>
    <div class="flex flex-col md:flex-row md:justify-between md:gap-x-[100px] gap-y-[10px] mt-[25px] md:mt-[48px]">
      <div>
        <NuxtImg src="/wellbeing/aspects/1.svg" class="w-[565px]"/>
      </div>
      <div>
        <NuxtImg src="/wellbeing/aspects/2.svg" class="w-[565px]"/>
      </div>
    </div>
    <div>
      <p class="font-avenir opacity-60 text-[16px] md:text-[30px] mt-[24px] text-center leading-[1.4]">{{ t('b2b.wellbeing.aspects.description') }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import Chip from '../ui/Chip.vue';

const { t } = useI18n();

</script>

